'use client';

import { c as _c } from "react/compiler-runtime";
import { Shuffle } from 'lucide-react';
import { useState } from 'react';
import { weeklyScores } from '@/lib/fantasy-extras';
export function WhatIfShuffle() {
  const $ = _c(30);
  const m = new Map();
  for (const r of weeklyScores) {
    const rows = m.get(r.event);
    if (rows) {
      rows.push(r);
    } else {
      m.set(r.event, [r]);
    }
  }
  const byEvent = m;
  const t = new Map();
  for (const r_0 of weeklyScores) {
    let tt = t.get(r_0.team);
    if (!tt) {
      tt = {
        team: r_0.team,
        manager: r_0.manager,
        points: 0,
        pointsFor: 0,
        wins: 0,
        losses: 0,
        draws: 0
      };
      t.set(r_0.team, tt);
    }
    tt.pointsFor = tt.pointsFor + r_0.pointsFor;
    if (r_0.result === "W") {
      tt.points = tt.points + 3;
      tt.wins = tt.wins + 1;
    } else {
      if (r_0.result === "D") {
        tt.points = tt.points + 1;
        tt.draws = tt.draws + 1;
      } else {
        tt.losses = tt.losses + 1;
      }
    }
  }
  const actual = [...t.values()].toSorted(_temp);
  const [seed, setSeed] = useState(0);
  let t0;
  bb0: {
    if (seed === 0) {
      t0 = null;
      break bb0;
    }
    let s = seed * 2654435761 >>> 0;
    const rand = () => {
      s = s * 1664525 + 1013904223 >>> 0;
      return s / 4294967295;
    };
    const t_0 = new Map();
    for (const r_1 of weeklyScores) {
      if (!t_0.has(r_1.team)) {
        t_0.set(r_1.team, {
          team: r_1.team,
          manager: r_1.manager,
          points: 0,
          pointsFor: 0,
          wins: 0,
          losses: 0,
          draws: 0
        });
      }
    }
    for (const [, rows_0] of byEvent) {
      let byeRow;
      for (const row of rows_0) {
        if (row.opponent === "AVERAGE") {
          byeRow = row;
          break;
        }
      }
      if (byeRow) {
        const tt_0 = t_0.get(byeRow.team);
        tt_0.pointsFor = tt_0.pointsFor + byeRow.pointsFor;
        if (byeRow.result === "W") {
          tt_0.points = tt_0.points + 3;
          tt_0.wins = tt_0.wins + 1;
        } else {
          if (byeRow.result === "D") {
            tt_0.points = tt_0.points + 1;
            tt_0.draws = tt_0.draws + 1;
          } else {
            tt_0.losses = tt_0.losses + 1;
          }
        }
      }
      const seen = new Map();
      for (const r_2 of rows_0) {
        if (r_2.opponent === "AVERAGE") {
          continue;
        }
        if (!seen.has(r_2.team)) {
          seen.set(r_2.team, r_2.pointsFor);
        }
      }
      const teams = [...seen.entries()];
      for (let i = teams.length - 1; i > 0; i--) {
        const j = Math.floor(rand() * (i + 1));
        const [t1, t2] = [teams[j], teams[i]];
        teams[i] = t1;
        teams[j] = t2;
      }
      for (let i_0 = 0; i_0 + 1 < teams.length; i_0 = i_0 + 2, i_0) {
        const [aTeam, aPts] = teams[i_0];
        const [bTeam, bPts] = teams[i_0 + 1];
        const a_0 = t_0.get(aTeam);
        const b_0 = t_0.get(bTeam);
        a_0.pointsFor = a_0.pointsFor + aPts;
        b_0.pointsFor = b_0.pointsFor + bPts;
        if (aPts > bPts) {
          a_0.points = a_0.points + 3;
          a_0.wins = a_0.wins + 1;
          b_0.losses = b_0.losses + 1;
        } else {
          if (bPts > aPts) {
            b_0.points = b_0.points + 3;
            b_0.wins = b_0.wins + 1;
            a_0.losses = a_0.losses + 1;
          } else {
            a_0.points = a_0.points + 1;
            b_0.points = b_0.points + 1;
            a_0.draws = a_0.draws + 1;
            b_0.draws = b_0.draws + 1;
          }
        }
      }
    }
    t0 = [...t_0.values()].toSorted(_temp2);
  }
  const shuffled = t0;
  const display = shuffled ?? actual;
  const actualRankByTeam = new Map(actual.map(_temp3));
  const t1 = "fantasy-reveal border-y border-[#24122f] bg-[#24122f] text-white";
  const t2 = "mx-auto max-w-7xl px-5 py-14 sm:px-8";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div><h2 className="font-sans text-5xl font-semibold">What if the schedule was random?</h2><p className="mt-3 max-w-2xl text-base leading-7 font-semibold text-[#e8ddca]">Same scores. Different opponents. Re-rolls every gameweek's pairings and recomputes the table. Run it once, run it twenty times. Son Doku's grievance is not in your head.</p></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setSeed(_temp4);
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Shuffle className="size-4" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = seed === 0 ? "Re-pair every gameweek" : "Re-roll";
  let t7;
  if ($[3] !== t6) {
    t7 = <button type="button" onClick={t4} className="inline-flex items-center gap-2 border border-[#e2c078] bg-[#e2c078] px-5 py-3 font-sans text-sm font-black text-[#24122f] uppercase transition hover:bg-[#fff5d6]">{t5}{t6}</button>;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== seed) {
    t8 = seed !== 0 && <button type="button" onClick={() => setSeed(0)} className="text-xs font-black text-[#e8ddca] uppercase underline">Show actual table</button>;
    $[5] = seed;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t7 || $[8] !== t8) {
    t9 = <div className="mb-6 grid gap-6 lg:grid-cols-[1fr_360px]">{t3}<div className="flex flex-col items-start gap-3 lg:items-end">{t7}{t8}</div></div>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = "overflow-hidden border border-[#6c5876] bg-[#fffaf1] text-[#24122f]";
  const t11 = "w-full text-left";
  const t12 = seed === 0 ? "Rank" : "New rank";
  let t13;
  if ($[10] !== t12) {
    t13 = <th className="px-4 py-3">{t12}</th>;
    $[10] = t12;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <th className="px-4 py-3">Team</th>;
    t15 = <th className="px-4 py-3">Manager</th>;
    t16 = <th className="px-4 py-3 text-right">Pts</th>;
    t17 = <th className="px-4 py-3 text-right">PF</th>;
    t18 = <th className="px-4 py-3 text-right">W-D-L</th>;
    $[12] = t14;
    $[13] = t15;
    $[14] = t16;
    $[15] = t17;
    $[16] = t18;
  } else {
    t14 = $[12];
    t15 = $[13];
    t16 = $[14];
    t17 = $[15];
    t18 = $[16];
  }
  let t19;
  if ($[17] !== seed) {
    t19 = seed !== 0 && <th className="px-4 py-3 text-right">vs actual</th>;
    $[17] = seed;
    $[18] = t19;
  } else {
    t19 = $[18];
  }
  let t20;
  if ($[19] !== t13 || $[20] !== t19) {
    t20 = <thead className="bg-[#f3ede0] text-xs font-black uppercase"><tr>{t13}{t14}{t15}{t16}{t17}{t18}{t19}</tr></thead>;
    $[19] = t13;
    $[20] = t19;
    $[21] = t20;
  } else {
    t20 = $[21];
  }
  const t21 = display.map((row_0, i_2) => {
    const newRank = i_2 + 1;
    const oldRank = actualRankByTeam.get(row_0.team) ?? newRank;
    const delta = oldRank - newRank;
    return <tr key={row_0.team} className="border-t border-[#d7c9b7]"><td className="px-4 py-3 font-sans text-2xl font-black">{newRank}</td><td className="px-4 py-3 text-sm font-black">{row_0.team}</td><td className="px-4 py-3 text-sm font-semibold text-[#6f6078]">{row_0.manager}</td><td className="px-4 py-3 text-right font-sans text-xl font-black">{row_0.points}</td><td className="px-4 py-3 text-right text-sm font-semibold tabular-nums">{row_0.pointsFor}</td><td className="px-4 py-3 text-right text-sm font-semibold tabular-nums">{row_0.wins}-{row_0.draws}-{row_0.losses}</td>{seed !== 0 && <td className="px-4 py-3 text-right text-sm font-black">{delta > 0 ? <span className="text-[#3a7a47]">↑{delta}</span> : delta < 0 ? <span className="text-[#a13a3a]">↓{Math.abs(delta)}</span> : <span className="text-[#888]">-</span>}</td>}</tr>;
  });
  let t22;
  if ($[22] !== t21) {
    t22 = <tbody>{t21}</tbody>;
    $[22] = t21;
    $[23] = t22;
  } else {
    t22 = $[23];
  }
  let t23;
  if ($[24] !== t20 || $[25] !== t22) {
    t23 = <div className={t10}><table className={t11}>{t20}{t22}</table></div>;
    $[24] = t20;
    $[25] = t22;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t23 || $[28] !== t9) {
    t24 = <section className={t1}><div className={t2}>{t9}{t23}</div></section>;
    $[27] = t23;
    $[28] = t9;
    $[29] = t24;
  } else {
    t24 = $[29];
  }
  return t24;
}
function _temp4(value) {
  return value + 1 || 1;
}
function _temp3(t_1, i_1) {
  return [t_1.team, i_1 + 1];
}
function _temp2(a_1, b_1) {
  return b_1.points - a_1.points || b_1.pointsFor - a_1.pointsFor;
}
function _temp(a, b) {
  return b.points - a.points || b.pointsFor - a.pointsFor;
}